import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import logo from "../../img/logo.png";
import $ from "jquery";
const Sidebar = () => {
  useEffect(() => {
    // Add jQuery logic here
    $(".sidebar-nav-item").on("click", function () {
      $(this).find(".sub-group-menu").slideToggle();
    });

    $(".sidebar-nav-item").on("click", function () {
      $(this).toggleClass("active");
    });
    // Cleanup event listener on component unmount
    return () => {
      $(".sidebar-nav-item").off("click");
    };
  }, []);
  return (
    <>
      <div className="sidebar-main sidebar-menu-one sidebar-expand-md sidebar-color">
        <div className="mobile-sidebar-header d-md-none">
          <div className="header-logo">
            <Link to="index.html">
              <img src={logo} alt="logo" />
            </Link>
          </div>
        </div>
        <div className="sidebar-menu-content">
          <ul className="nav nav-sidebar-menu sidebar-toggle-view">
            <li className="nav-item sidebar-nav-item">
              <Link className="nav-link">
                <i className="flaticon-dashboard" />
                <span>Dashboard</span>
              </Link>
              <ul className="nav sub-group-menu">
                <li className="nav-item">
                  <Link to="/admin" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Admin
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/student" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Students
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/parent" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Parents
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/teacher" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Teachers
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item sidebar-nav-item">
              <a to="#" className="nav-link">
                <i className="flaticon-classmates" />
                <span>Students</span>
              </a>
              <ul className="nav sub-group-menu">
                <li className="nav-item">
                  <Link to="/allstudent" className="nav-link">
                    <i className="fas fa-angle-right" />
                    All Students
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/studentDetail" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Student Details
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/admission" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Admission Form
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/studentPromotion" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Student Promotion
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item sidebar-nav-item">
              <Link to="#" className="nav-link">
                <i className="flaticon-multiple-users-silhouette" />
                <span>Teachers</span>
              </Link>
              <ul className="nav sub-group-menu">
                <li className="nav-item">
                  <Link to="/allTeachers" className="nav-link">
                    <i className="fas fa-angle-right" />
                    All Teachers
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/teacherDetails" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Teacher Details
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/addTeacher" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Add Teacher
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/payment" className="nav-link ">
                    <i className="fas fa-angle-right" />
                    Payment
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item sidebar-nav-item">
              <Link to="#" className="nav-link">
                <i className="flaticon-couple" />
                <span>Parents</span>
              </Link>
              <ul className="nav sub-group-menu">
                <li className="nav-item">
                  <Link to="/allParent" className="nav-link">
                    <i className="fas fa-angle-right" />
                    All Parents
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/parentDetail" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Parents Details
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/addParent" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Add Parent
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item sidebar-nav-item">
              <Link to="#" className="nav-link">
                <i className="flaticon-books" />
                <span>Library</span>
              </Link>
              <ul className="nav sub-group-menu">
                <li className="nav-item">
                  <Link to="/allBook" className="nav-link">
                    <i className="fas fa-angle-right" />
                    All Book
                  </Link>
                </li>
                <Link className="nav-item">
                  <a to="/addnewBook" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Add New Book
                  </a>
                </Link>
              </ul>
            </li>
            <li className="nav-item sidebar-nav-item">
              <Link to="#" className="nav-link">
                <i className="flaticon-technological" />
                <span>Acconunt</span>
              </Link>
              <ul className="nav sub-group-menu">
                <li className="nav-item">
                  <Link to="/allFees" className="nav-link">
                    <i className="fas fa-angle-right" />
                    All Fees Collection
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/expenses" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Expenses
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/addExpenses" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Add Expenses
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item sidebar-nav-item">
              <Link to="#" className="nav-link">
                <i className="flaticon-maths-class-materials-cross-of-a-pencil-and-a-ruler" />
                <span>Class</span>
              </Link>
              <ul className="nav sub-group-menu">
                <li className="nav-item">
                  <Link to="/allClasses" className="nav-link">
                    <i className="fas fa-angle-right" />
                    All Classes
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/addnewClasses" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Add New Class
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link to="/subject" className="nav-link">
                <i className="flaticon-open-book" />
                <span>Subject</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/classRutine" className="nav-link">
                <i className="flaticon-calendar" />
                <span>Class Routine</span>
              </Link>
            </li>
            <l className="nav-item">
              <Link to="/attendence" className="nav-link">
                <i className="flaticon-checklist" />
                <span>Attendence</span>
              </Link>
            </l>
            <li className="nav-item sidebar-nav-item">
              <Link to="#" className="nav-link">
                <i className="flaticon-shopping-list" />
                <span>Exam</span>
              </Link>
              <ul className="nav sub-group-menu">
                <li className="nav-item">
                  <Link to="/examSchedule" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Exam Schedule
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/examGrades" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Exam Grades
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link to="/transport" className="nav-link">
                <i className="flaticon-bus-side-view" />
                <span>Transport</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/hostel" className="nav-link">
                <i className="flaticon-bed" />
                <span>Hostel</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/notice" className="nav-link">
                <i className="flaticon-script" />
                <span>Notice</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/message" className="nav-link">
                <i className="flaticon-chat" />
                <span>Messeage</span>
              </Link>
            </li>
            <li className="nav-item sidebar-nav-item">
              <Link to="#" className="nav-link">
                <i className="flaticon-menu-1" />
                <span>UI Elements</span>
              </Link>
              <ul className="nav sub-group-menu">
                <li className="nav-item">
                  <Link to="/alert" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Alart
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/button" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Button
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/grid" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Grid
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/modal" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Modal
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/progressBar" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Progress Bar
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/tab" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Tab
                  </Link>
                </li>
                <li className="nav-item">
                  <Link to="/widget" className="nav-link">
                    <i className="fas fa-angle-right" />
                    Widget
                  </Link>
                </li>
              </ul>
            </li>
            <li className="nav-item">
              <Link to="/map" className="nav-link">
                <i className="flaticon-planet-earth" />
                <span>Map</span>
              </Link>
            </li>
            <li className="nav-item">
              <Link to="/accountSetting" className="nav-link">
                <i className="flaticon-settings" />
                <span>Account</span>
              </Link>
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Sidebar;
